define([
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min',
  'readingiq-src/js/config/levels-config'
], function groupStateModule(aoflModules, levelsConfig) {
  'use strict';
  var objectUtils = aoflModules.objectUtils;
  var READING_LEVEL_MAP = levelsConfig.maps.groupReadingLevels.camelToSnake;

  var state = function state(avatarModelService) {
    var NAMESPACE = 'group';
    var ALIAS = 'group';

    var mutations = {
      init: function init() {
        return {
          label: '',
          profiles: [],
          groupUuid: '',
          groupType: '',
          ownerUserUuid: '',
          createdDate: '',
          updatedDate: '',
          uploadedStudents: false,
          groupDetails: {
            name: '',
            groupLevelType: ''
          },
          errorCode: 0
        };
      },
      update: function update(_moduleState, _payload) {
        return Object.assign({}, _moduleState, _payload);
      },
      updateProfiles: function updateProfiles(_moduleState, _payload) {
        var payload = {
          profiles: _payload
        };
        return Object.assign({}, _moduleState, payload);
      },
      updateProfile: function updateProfile(_moduleState, _payload) {
        var profiles = _moduleState.profiles;
        var updatedProfiles = profiles.map(function(profile) {
          if (profile.profileUuid === _payload.profileUuid) {
            return _payload;
          }
          return profile;
        });
        return Object.assign({}, _moduleState, {profiles: updatedProfiles});
      },
      removeProfile: function removeProfile(_moduleState, _payload) {
        var profiles = _moduleState.profiles;
        var updatedProfiles = profiles.filter(function(profile) {
          return profile.profileUuid !== _payload;
        });
        return Object.assign({}, _moduleState, {profiles: updatedProfiles});
      },
      setGroupLevelType: function setGroupLevelType(_moduleState, _payload) {
        return objectUtils.deepAssign(_moduleState, 'groupDetails', {
          groupLevelType: _payload
        });
      },
      setDefaultGradeLevel: function setDefaultGradeLevel(
        _moduleState,
        gradeLevelId
      ) {
        return {..._moduleState, ...{defaultGradeLevel: gradeLevelId}};
      },
      error: function error(_moduleState, _payload) {
        return Object.assign({}, _moduleState, _payload);
      }
    };

    var decorators = [
      function formatEmptyAddChild(_nextState) {
        var nextState = _nextState;
        var $addChildArr = [];
        var hasGroupProfiles =
          nextState[NAMESPACE] && nextState[NAMESPACE].profiles;
        var isTeacher =
          nextState.user &&
          nextState.user.$role &&
          (nextState.user.$role === 'TEACHER' ||
            nextState.user.$role === 'TEACHER_EMS');
        if (hasGroupProfiles && !isTeacher) {
          var profiles = nextState[NAMESPACE].profiles;
          var totalAddChild = 3 - profiles.length;
          var addChildMap = {
            1: [1],
            2: [1, 2],
            3: [1, 2, 3]
          };
          $addChildArr = addChildMap[totalAddChild];
          nextState[NAMESPACE] = Object.assign({}, nextState[NAMESPACE], {
            $addChildArr: $addChildArr
          });
        }
        return nextState;
      },
      function isGroupOwner(_nextState) {
        var nextState = _nextState;
        var hasOwnerUuid =
          nextState[NAMESPACE] && nextState[NAMESPACE].ownerUserUuid;
        var hasGroupProfiles =
          nextState[NAMESPACE].profiles &&
          nextState[NAMESPACE].profiles.length > 0;
        if (hasOwnerUuid && hasGroupProfiles) {
          var profiles = nextState[NAMESPACE].profiles.map(function(profile) {
            var isGroupOwner =
              nextState[NAMESPACE].ownerUserUuid === profile.userUuid;
            return Object.assign({}, profile, {isGroupOwner: isGroupOwner});
          });
          nextState[NAMESPACE] = Object.assign({}, nextState[NAMESPACE], {
            profiles: profiles
          });
        }
        return nextState;
      },
      function sortProfilesByName(_nextState) {
        var nextState = _nextState;
        var hasGroupProfiles =
          nextState[NAMESPACE] &&
          nextState[NAMESPACE].profiles &&
          nextState[NAMESPACE].profiles.length > 0;
        var isTeacher =
          nextState.user &&
          nextState.user.$role &&
          (nextState.user.$role === 'TEACHER' ||
            nextState.user.$role === 'TEACHER_EMS');
        if (hasGroupProfiles && isTeacher) {
          var sortedProfiles = nextState[NAMESPACE].profiles
            .concat([])
            .sort(function(a, b) {
              var nameA =
                typeof a.profileDetails === 'object' && a.profileDetails.name
                  ? a.profileDetails.name
                  : '';
              var nameB =
                typeof b.profileDetails === 'object' && b.profileDetails.name
                  ? b.profileDetails.name
                  : '';
              return nameA.localeCompare(nameB);
            });
          return objectUtils.deepAssign(nextState, NAMESPACE, {
            profiles: sortedProfiles
          });
        }
        return nextState;
      },
      function formatDisplayReadingLevels(_nextState) {
        var nextState = _nextState;
        var hasProfiles =
          nextState[NAMESPACE] &&
          nextState[NAMESPACE].profiles &&
          nextState[NAMESPACE].profiles.length > 0;
        var hasGroupLevelType =
          nextState[NAMESPACE] &&
          nextState[NAMESPACE].groupDetails &&
          nextState[NAMESPACE].groupDetails.groupLevelType;
        var hasReadingLevels =
          nextState.level &&
          nextState.level.readingLevelOptions &&
          nextState.level.readingLevelOptions.length > 0;
        var isTeacher =
          nextState.user &&
          nextState.user.$role &&
          (nextState.user.$role === 'TEACHER' ||
            nextState.user.$role === 'TEACHER_EMS');
        if (hasProfiles && hasGroupLevelType && hasReadingLevels && isTeacher) {
          var readingLevelOptions = nextState.level.readingLevelOptions;
          var readingLevelOptionsMap = levelsConfig.getReadingLevelOptionsMap(
            readingLevelOptions
          );
          var groupLevelType = nextState[NAMESPACE].groupDetails.groupLevelType;
          var profiles = nextState[NAMESPACE].profiles.map(function(profile) {
            var displayReadingLevel = [];
            if (!profile.isGroupOwner) {
              var activeReadingLevel =
                profile.profileDetails.activeReadingLevel;
              var activeReadingLevelType =
                profile.profileDetails.activeReadingLevelType;
              if (
                activeReadingLevel &&
                activeReadingLevel.length > 0 &&
                activeReadingLevelType === groupLevelType
              ) {
                displayReadingLevel = activeReadingLevel.map(function(levelId) {
                  var level = readingLevelOptionsMap[levelId];
                  var levelDisplay = '';
                  levelDisplay =
                    level && groupLevelType === READING_LEVEL_MAP.gradeLevel
                      ? ' ' + level.decoration.shortLabel
                      : ' ' + level.label;
                  return levelDisplay;
                });
              }
            }
            return Object.assign({}, profile, {
              displayReadingLevel: displayReadingLevel.toString()
            });
          });
          return objectUtils.deepAssign(nextState, NAMESPACE, {
            profiles: profiles
          });
        }
        return nextState;
      },
      function getAvatarURL(_nextState) {
        var nextState = _nextState;
        var hasProfiles =
          nextState[NAMESPACE] &&
          nextState[NAMESPACE].profiles &&
          nextState[NAMESPACE].profiles.length > 0;
        if (hasProfiles) {
          var profiles = nextState[NAMESPACE].profiles.map(function(profile) {
            var details = profile.profileDetails;
            var hasNoAvatarUrl =
              details && details.avatar && !details.avatarUrl;
            if (hasNoAvatarUrl) {
              details = Object.assign({}, details, {
                avatarUrl: avatarModelService.getAvatarUrl(
                  profile.profileDetails.avatar
                )
              });
            }
            return Object.assign({}, profile, {profileDetails: details});
          });
          return objectUtils.deepAssign(nextState, NAMESPACE, {
            profiles: profiles
          });
        }
        return nextState;
      },
      function sortActiveReadingLevel(_nextState) {
        var nextState = _nextState;
        var hasProfiles =
          nextState[NAMESPACE] &&
          nextState[NAMESPACE].profiles &&
          nextState[NAMESPACE].profiles.length > 0;
        if (hasProfiles) {
          var profiles = nextState[NAMESPACE].profiles.map(function(profile) {
            var details = profile.profileDetails;
            var hasActiveReadingLevel =
              details && details.avatar && details.activeReadingLevel;
            if (hasActiveReadingLevel) {
              details.activeReadingLevel.concat([]).sort();
            }
            return Object.assign({}, profile, {profileDetails: details});
          });
          return objectUtils.deepAssign(nextState, NAMESPACE, {
            profiles: profiles
          });
        }
        return nextState;
      }
    ];

    return {
      namespace: NAMESPACE,
      alias: ALIAS,
      mutations: mutations,
      decorators: decorators
    };
  };
  return state;
});
